/**
 * Browser side of the sign-in page's language cookie. Only the sign-in page's
 * selector writes it, and only signed-out renders read it (i18n/resolveLocale),
 * so the app's language never carries into the sign-in page. Sign-out clears
 * it, so the next person at the browser starts from its own language.
 */
import type { Locale } from '@/i18n/config';
import { SIGNIN_LOCALE_COOKIE } from '@/i18n/resolveLocale';

const ONE_YEAR_S = 365 * 24 * 60 * 60;

export function writeSigninLocaleCookie(locale: Locale): void {
  document.cookie = `${SIGNIN_LOCALE_COOKIE}=${locale}; path=/; max-age=${ONE_YEAR_S}; SameSite=Lax`;
}

export function clearSigninLocaleCookie(): void {
  document.cookie = `${SIGNIN_LOCALE_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
}
